import * as _4 from 'lodash4';
import { IEmptyListScheduledText } from '../../interfaces/registration_interfaces';
import { TermCourseQuery } from '../../../term_courses/queries/term_courses_query';
import { SectionSwapServant } from '../../../../swap/servants/section_swap_servant';
import { BackToPlannerHelper } from '../../../../components/back_to_planner/helpers/back_to_planner_helper';
import { SearchAndCourseFeatureFacade } from '../../../../search_and_add_courses/facades/search_and_courses_feature_facade';
import { SchedulerModel } from '../../../course_scheduler/models/scheduler_model';
class EmptyCourseListMessage {
  private emptyCourseListCustomTextMessage: string = '';
  private displayText: IEmptyListScheduledText;
  private scheduledSectionsCount: number;
  private waitlistCount: number;

  constructor(
    private ngSchedulerModel: SchedulerModel,
    private $state: ng.ui.IStateService,
    private ngSectionSwapServant: SectionSwapServant,
    private ngTermCourseQuery: TermCourseQuery,
    private ngBackToPlannerHelper: BackToPlannerHelper,
    private ngSearchAndCourseFeatureFacade: SearchAndCourseFeatureFacade
  ) {}

  backToPlanner() {
    if (this.ngBackToPlannerHelper.isPlannerDisabled() && this.ngSearchAndCourseFeatureFacade.isFeatureEnabled) {
      return this.$state.go('my.schedule.searchandaddcourses');
    }
    return this.ngBackToPlannerHelper.navigateToPlanner();
  }

  $onInit() {
    this.emptyCourseListCustomTextMessage = _4.get(
      this.ngSchedulerModel.read(),
      'customtext.AP3_EMPTY_COURSE_LIST_MSG.text',
      ''
    );
    this.__reflectUpdates();
  }
  $onChanges() {
    this.__reflectUpdates();
  }

  __reflectUpdates() {
    this.displayText = this.getDisplayText();
  }

  getDisplayText() {
    return { header: this.emptyCourseListCustomTextMessage, footer: '' };
  }
}

class EmptyCourseListMessageComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: any;
  constructor() {
    this.bindings = {
      waitlistCount: '<',
      scheduledSectionsCount: '<'
    };
    this.controller = EmptyCourseListMessage;
    this.templateUrl =
      'capability-ng-scheduler/src/views/registration/components/empty_course_list_message/empty_course_list_message.html';
  }
}

angular.module('capability-ng-scheduler').component('emptyCourseListMessage', new EmptyCourseListMessageComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/components/empty_course_list_message/empty_course_list_message.ts